import { CrewMember } from '@legacy-types';

import { useData } from '@shared/api/hooks/useData';
import { Portlet } from '@shared/ui/components/Portlet';
import { WristbandsDataTable } from '@shared/wristbands/components/WristbandsDataTable';
import { getWristbands } from '@shared/wristbands/endpoints/getWristbands';

type WristbandData = App.Domain.Wristband.Data.WristbandData;

type ShowUserRegistrationWristbandsProps = {
  crewMember: CrewMember;
};

export function ShowUserRegistrationWristbands({ crewMember }: ShowUserRegistrationWristbandsProps) {
  const wristbands = useData<WristbandData>({
    get: getWristbands,
    query: {
      filter: { crew_member_id: crewMember.id },
      include: ['accessVoucher.accessVoucherTemplate.period'],
      page: { size: 20 },
    },
    history: false,
  });

  return (
    <Portlet title="Wristbands">
      <WristbandsDataTable wristbands={wristbands} withoutFilters avoidPagination />
    </Portlet>
  );
}
